import React, {useCallback, useEffect, useState} from 'react';
import {useTranslation} from "react-i18next";
import {callAlertWeb, callNativeWeb, clickMoveToAppWeb, footerShowEventWeb} from "common/appInterface";
import {useLocation, useNavigate} from "react-router";
import {Location} from "history";
import StringUtils from "common/stringUtils";
import client from "lib/CommonApi/client";
import {AxiosError} from "axios";
import {inquiryFunctionAppVersion} from "../../api/SelfCommonAPI";


const DepositCardIssuanceFeePage: React.FC = () => {
    /** Location State */
    const location = useLocation() as Location<LocationState>;
    /** Navigate */
    const navigate = useNavigate();
    /** 다국어처리 */
    const { t } = useTranslation();

    const screenId = "APPL22";
    const screenName = t("APPL22.title");

    const [cardApply] = useState<Partial<CardApplyCommon>>(location.state.apply);

    /** 미납금 납부 App Version */
    const [payPendingFeeVersion, setPayPendingFeeVersion] = useState<number | null>(null);

    /**
     * dhbyun
     * CARD_PAY_PENDING_FEE 조회
     */
    const cardPayPendingFeeVersionApi = useCallback(
        async () => {
            await inquiryFunctionAppVersion("CARD_PAY_PENDING_FEE", location)
                .then((res) => {
                    if (res.data.resData) {
                        setPayPendingFeeVersion(res.data.resData.version);
                    }
                }).catch((e: AxiosError) => {
                    callAlertWeb("ERROR", "99", e.message);
                });
        },
        [location]
    );

    /** 메인 이동 (완료 버튼 / 뒤로가기 공통) */
    const goMain = useCallback(() => {
        navigate("/main", { state: { query: location.state.query, swiperIndex: 0, tabIndex: "1" }});
    }, [navigate, location]);

    /** 뒤로가기 처리 (backKeyEvent_App (APP > WEB)) — 백키/하드웨어 back 공통. 신청취소 없이 완료 버튼과 동일하게 메인 이동 */
    const callbackBackkeyEvent = useCallback(() => {
        goMain();
    }, [goMain]);

    /** 신청완료 후처리 호출 */
    const callComplet = useCallback(async () => {
        await client.patch("/api/app/apply/complet", { ...location.state.query, receiveSeq: cardApply.receiveSeq, receiveDate: cardApply.receiveDate }).then((response) => {
            let result = response.data.response;
            console.log(result);
        }).catch((e: AxiosError) => {
            callAlertWeb("ERROR", "99", e.message);
        });
    }, [location, cardApply]);

    // 최초실행
    useEffect(() => {
        // callNative_Web 처리 (WEB > APP)
        // callNativeWeb(screenId, screenName);
        callNativeWeb(screenId, screenName);
        // 하단바 숨기기
        footerShowEventWeb("N");

        callComplet();
        cardPayPendingFeeVersionApi();

        // 최초한번실행 useEffect() Warning 제거
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // 뒤로가기 이벤트 리스너 (backKeyEvent_App (APP > WEB))
    useEffect(() => {
        document.addEventListener('backpress', callbackBackkeyEvent);
        return () => document.removeEventListener('backpress', callbackBackkeyEvent);
    }, [callbackBackkeyEvent]);

  return (
    <div id="wrap">
      <div id="container" className="pcHidden">
          <section className="contents pb64-mb">
              <div className="cardWrap5">
                  <div className="txtWrap">
                      <p className="mainTxt">{t("APPL22.explan01")}</p>
                  </div>
                  <div className="txtWrap">
                      <p className="txtLine">{t("APPL22.explan02")}</p>
                      <p className="txtLine">{t("APPL22.explan03")}</p>
                  </div>
                  <div className="txtBox">
                      <p>{`${t("APPL22.explan04")} : ${StringUtils.moneyFormat(StringUtils.nvlDefault(location.state.storage?.displayCardIssueFee, "0"))} ${t("COMMON.krw")}`}</p>
                      <p>{`${t("APPL22.explan05")} : ${StringUtils.dateFormatDefault(location.state.storage?.chargeCardIssueFeeRes?.depositLimitDate)}`}</p>
                  </div>
                  <div className="txtWrap">
                      <p className="noticeTxt">{t("APPL22.explan06")}</p>
                  </div>
              </div>
         </section>
          <div className="btnArea">
              <div className="btnWrapTy01">
                  {
                      (
                          location.state.query.apiVersion != null
                          && payPendingFeeVersion != null
                          && parseInt(location.state.query.apiVersion) >= payPendingFeeVersion
                      )
                          ? (
                              <button type="button" className="btnPrimaryTy01"
                                      disabled={(location.state.query.apiVersion == null || payPendingFeeVersion == null)
                                          || (parseInt(location.state.query.apiVersion) < payPendingFeeVersion!)}
                                      onClick={() => clickMoveToAppWeb("N039")}
                              >
                                  <span>{t("APPL22.button01")}</span>
                              </button>
                          ) : (
                              <button type="button" className="btnPrimaryTy01"
                                      onClick={goMain}
                              >
                                  <span>{t("COMMON.button.done")}</span>
                              </button>
                          )
                  }
              </div>
          </div>
      </div>
    </div>
  );
};

export default DepositCardIssuanceFeePage;